// Persistance navigateur des liens de partage actifs (ADR 0006, incrément
// « QR réaffichable »). Le backend ne stocke que le SHA-256 du jeton et ne
// peut pas restituer le lien : pour permettre au propriétaire de réafficher
// le QR du même partage après fermeture de la modale, le lien complet est
// conservé localement, par (projectId, shareId), dans localStorage.
//
// Limites assumées (décision A, 2026-09-06) :
// - portée = ce navigateur uniquement ; un autre appareil/navigateur doit
//   créer un nouveau lien (la révocation + recréation reste possible) ;
// - le lien est retiré dès la révocation connue du client ;
// - modèle de menace inchangé : compromission localStorage ≠ compromission
//   de la base (le jeton n'y figure que côté client, comme dans l'URL).
const STORAGE_KEY = "roadmaker.shareLinks.v1";

const safeLocalStorage = () => {
  try {
    return window.localStorage;
  } catch (_) {
    // Navigation privée / stockage désactivé : réaffichage indisponible,
    // le flux « affiché une fois à la création » reste fonctionnel.
    return null;
  }
};

const readStore = () => {
  const storage = safeLocalStorage();
  if (!storage) return {};
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return parsed;
  } catch (_) {
    return {};
  }
};

const writeStore = (store) => {
  const storage = safeLocalStorage();
  if (!storage) return;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (_) {
    // Quota dépassé : ignorer silencieusement, sans casser le panneau.
  }
};

const shareKey = (projectId, shareId) => `${projectId}::${shareId}`;

export const shareLinkStore = {
  // Enregistre le lien d'un partage ACTIF. Écrase une éventuelle valeur
  // précédente pour le même shareId (recréation impossible : un shareId
  // n'est créé qu'une fois).
  save(projectId, shareId, link) {
    if (!projectId || !shareId || !link) return;
    const store = readStore();
    store[shareKey(projectId, shareId)] = { link, savedAt: Date.now() };
    writeStore(store);
  },

  // Retourne le lien mémorisé, ou null si absent/révoqué.
  load(projectId, shareId) {
    if (!projectId || !shareId) return null;
    const entry = readStore()[shareKey(projectId, shareId)];
    if (!entry || typeof entry.link !== "string") return null;
    return entry.link;
  },

  // Retire le lien (révocation, disparition du partage).
  remove(projectId, shareId) {
    if (!projectId || !shareId) return;
    const store = readStore();
    if (Object.prototype.hasOwnProperty.call(store, shareKey(projectId, shareId))) {
      delete store[shareKey(projectId, shareId)];
      writeStore(store);
    }
  },
};
